import { PlanRoute } from "../services/planroute/planroute.service.mjs";
import { PlanRouteParams } from "../services/planroute/planrouteparams.mjs"
import { PlannerParams } from "../view/planner.view.mjs";

export function widgetControllerProvider(multipleDataSource, belfortSigDataSource, mainView){


    class WidgetController{
        constructor(){
            var env = 'prod';
            var instance = 'belfort';
            var _planRoute = new PlanRoute(env, instance);

            Object.defineProperty(this,'multipleDataSource',{
                get : function(){ return multipleDataSource }
            });

            Object.defineProperty(this,'planRoute',{
                get : function(){ 
                    return _planRoute; 
                }
            });
            
        }


        getPlannerView(){ return mainView.getPlannerView() }

        getPlanRoute(){ return this.planRoute; }

        getRouteParams(){ return this.routeParams }

        addOriginSelectorBan(){
            var plannerView = this.getPlannerView();
            plannerView.addOriginBan();
        }

        addDestinationSelectorBan(){
            var plannerView = this.getPlannerView();
            plannerView.addDestinationBan();
        }

        addOriginSelectorPois(pois){
            var plannerView = this.getPlannerView();
            plannerView.addOriginPois(pois);
        }

        addDestinationSelectorPois(pois){
            var plannerView = this.getPlannerView();
            plannerView.addDestinationPois(pois);
        }

        addOriginSelectorStops(stops){
            var plannerView = this.getPlannerView();
            plannerView.addOriginStops(stops);
        }

        addDestinationSelectorStops(stops){
            var plannerView = this.getPlannerView();
            plannerView.addDestinationStops(stops);
        }

        addPlannerViewSelectorHandler(){
            var plannerView = this.getPlannerView();
            var handler = (plannerParams) => { 
                var planRouteParams = this.getPlanRouteParams(plannerParams);
                console.log('planRouteParams', planRouteParams); 
                var url = this.buildPlanRouteUrl(planRouteParams);
                console.log('url',url)
                this.loadUrl(url)
            }
            plannerView.addSelectEventHandler(handler);
        }

        getPlanRouteParams(plannerParams){
            var planRouteParams = new PlanRouteParams();

            var origin = plannerParams.getOrigin();
            var datasetName = plannerParams.getOriginDatasetName();
            var coordinates = PlannerToPlanRouteTransformer.getCoordinates(origin, datasetName )
            planRouteParams.fromLon = coordinates[1];
            planRouteParams.fromLat = coordinates[0];
            planRouteParams.fromLabel = PlannerToPlanRouteTransformer.getLabel(origin, datasetName)

            var destination = plannerParams.getDestination();
            var datasetName = plannerParams.getDestinationDatasetName();
            var coordinates = PlannerToPlanRouteTransformer.getCoordinates(destination, datasetName);
            planRouteParams.toLon = coordinates[1];
            planRouteParams.toLat = coordinates[0];
            planRouteParams.toLabel = PlannerToPlanRouteTransformer.getLabel(destination, datasetName) 

            planRouteParams.deparr = plannerParams.getDeparr();
            planRouteParams.date = plannerParams.getDate();
            planRouteParams.time = plannerParams.getTime();
            planRouteParams.planner = plannerParams.getPlanner();

            return planRouteParams;
        }


        buildPlanRouteUrl(planRouteParams){
            var planRoute = this.getPlanRoute();
            planRoute.data = planRouteParams;
            return planRoute.url;
        }

        loadUrl(url){
            window.open(url, '_system') ;    
        }



        run(){

            this.addOriginSelectorBan();
            this.addDestinationSelectorBan();
            
            belfortSigDataSource.get().then((pois)=>{
                console.log('pois',pois);
                this.addOriginSelectorPois(pois);
                this.addDestinationSelectorPois(pois);
                //mainView.displayView('#view-mecatran-planner');
            })
            

            this.multipleDataSource.get().then((stops)=>{
                console.log('stops',stops)
                this.addOriginSelectorStops(stops);
                this.addDestinationSelectorStops(stops);
                this.addPlannerViewSelectorHandler();
            }).then(()=>{

                

                mainView.displayView('#view-mecatran-planner');
            });

            

        }
    }

    return new WidgetController();
}



/**
 * Transform PlannerParams into PlanRouteParams 
 */
class PlannerToPlanRouteTransformer{
    constructor(){}
    static getCoordinates(object, datasetName ){
        var ret = []
        switch(datasetName){
            case 'poi': // TMP should reference PlannerView.datasetName 
            case 'ban':
                ret = object.getGeometry().getCoordinates(); 
                ret = [ret[1],ret[0]]; // [lat,lon]
                break;
            case 'stop':
                ret = [object.getLatitude(), object.getLongitude() ]
                break;
        }
        return ret;
    }

    static getLabel(object, datasetName){
        var label = '';
        switch(datasetName){
            case 'poi':
                label = `${object.getProperties().getName()}-${object.getProperties().getCity()}`
                break;
            case 'ban':
                label = object.getProperties().getLabel();
                break;
            case 'stop':
                label = object.getName();
                break;
        }
        return label;
    }
}